import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import localePT from '@angular/common/locales/pt';
import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TitleStrategy } from '@angular/router';

// --- App ---
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// --- Pages ---
import { ServiceWorkerModule } from '@angular/service-worker';
import { PagesModule } from '@pages/pages.module';

// --- Interceptors ---
import { APIInterceptor } from '@interceptors/api.interceptor';
import { GlobalErrorInterceptor } from '@interceptors/global-error.interceptor';
import { TokenInterceptor } from '@interceptors/token.interceptor';

// --- PrimeNG ---
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';

// --- Utils ---
import { TemplatePageTitleStrategy } from '@utils/title-strategy.util';

registerLocaleData(localePT);

@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		HttpClientModule,
		ServiceWorkerModule.register('ngsw-worker.js', {
			enabled: false, // environment.production,
			// Register the ServiceWorker as soon as the application is stable
			// or after 30 seconds (whichever comes first).
			registrationStrategy: 'registerWhenStable:30000',
		}),

		// --- App Routing ---
		AppRoutingModule,

		// --- Pages ---
		PagesModule,
	],
	providers: [
		DialogService,
		{ provide: ErrorHandler, useClass: GlobalErrorInterceptor },
		{ provide: TitleStrategy, useClass: TemplatePageTitleStrategy },
		{
			provide: HTTP_INTERCEPTORS,
			useClass: APIInterceptor,
			multi: true,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: TokenInterceptor,
			multi: true,
		},
		{ provide: LOCALE_ID, useValue: 'pt-br' },

		// --- PrimeNG ---
		MessageService,
	],
	bootstrap: [AppComponent],
})
export class AppModule {}
